import { useParams } from "react-router-dom";

import { buSlugParam } from "routes/constants";

export const useGetEntityParamId = () => {
  const params = useParams();

  return params?.[buSlugParam] || "";
};
